<template>
  <div>
    <div>
      <div class="text-4 font-weight-medium">
        About {{ currentProject.text }}
      </div>
      <div class="d-flex mt-6">
        <div class="flex-1">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Staking Asset</div>
            <div class="flex-2 text-right">Staked Ratio</div>
            <div class="flex-3 text-right">Total Value Locked</div>
          </div>
          <div class="d-flex align-center px-2 px-md-6 py-2">
            <div class="flex-2">
              <div class="text-4 font-weight-medium text-uppercase">
                {{ currentProject.staking.token }}
              </div>
              <div class="gray--text text-5 mt-1">
                {{ currentProject.text }}
              </div>
            </div>
            <div class="flex-2 text-right">
              <span
                v-if="
                  validatorStakeInfo.result &&
                    validatorStakeInfo.result.stakedRatio
                "
              >
                {{
                  (validatorStakeInfo.result.stakedRatio * 100)
                    | numberFormat("0,0.00", false)
                }}
                %
              </span>
            </div>
            <div class="flex-3 text-right">
              <div>
                <span
                  class="font-weight-medium"
                  v-if="validatorStakeInfo.result"
                >
                  {{
                    validatorStakeInfo.result.totalStaked
                      | numberFormat("0,0.00", false)
                  }}
                </span>
                <span class="darkgray--text font-weight-light">
                  {{ currentProject.staking.token | uppercase }}
                </span>
              </div>
              <div
                v-if="validatorStakeInfo.result"
                class="text-6 mt-2 darkgray--text"
              >
                <span class="font-weight-medium">
                  {{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      validatorStakeInfo.result.totalStaked)
                      | currency
                  }}
                </span>
                <span>USD</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-10 d-none d-md-block" style="width:160px"></div>
      </div>
      <div class="mt-10 text-5 font-weight-light line-height-25">
        {{ currentProject.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters({
    currentProject: "projectConfig/latestProject",
    validatorStakeInfo: "staking/celer/validatorStakeInfo",
    getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
  }),
};
</script>
